import React from 'react'
import './style.css'
const Education = () => {
  return (
    <>
   
   <div className='Experience Education AboutInfoMain' >
     <div className="ExperienceInfo EducationInfo " style={{textDecoration:'none',textAlign:'start',color:'white'}}>
       <h3 style={{fontWeight:'600'}}>EDUCATION</h3>
       <p>2020 - 2023</p>
    </div>
    
     <div className="ExperienceInfo EducationInfo" style={{textDecoration:'none',textAlign:'start',color:'white'}}>
       <h3 style={{fontWeight:'600'}}>Bachelor Degree in Computer Application</h3>
       <p>Savatribai Phule Pune University</p>
    </div>
   
     <div className="ExperienceInfo EducationInfo " style={{textDecoration:'none',textAlign:'start',color:'white'}}>
       <p>2023 - 2025</p>
       <h3 style={{fontWeight:'600'}}>Master Degree in Computer Application</h3>
       <p>Sandip University</p>
    </div>
    
   </div>
    
    </>
  )
}

export default Education
